import { Component, OnInit, ViewChild, Inject, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatSnackBar } from '@angular/material';

import {Feed} from '../../../models/feed';
import {Comment} from '../../../models/comment';
import {FeedService} from '../../../services/feed.service';
import {AuthService} from '../../../services/auth.service';
import filestack from 'filestack-js';
import PerfectScrollbar from 'perfect-scrollbar';

declare var $: any;
import Swal from 'sweetalert2';

const apikey = 'A7zJTtgFRW6cWqHglvjIgz';
const client = filestack.init(apikey);

@Component({
  selector: 'app-modal-content',
  templateUrl: 'modal-content.component.html',
  styleUrls: ['./userpanel.component.css'],
  providers: [ FeedService, AuthService ]
})
export class ModalContentComponent implements OnInit {

  public form: FormGroup;
  loggedInUser
  public uploadedFileType: string;
  public uploadedFileUrl: string;
  loading = true;
  isFile = false;

  constructor(
    public dialogRef: MatDialogRef<ModalContentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    private feedService: FeedService,
    private authService: AuthService
  ) {
    this.buildForm();
  }


  ngOnInit() {
    this.getUsuarioLogado();
    this.form.get('id').setValue(this.data.id)
    this.form.get('texto').setValue(this.data.text)
    this.form.get('title').setValue(this.data.title)
    this.form.get('pasta_id').setValue(this.data.pasta_id)
    this.form.get('embed').setValue(this.data.embed)
    this.form.get('embedTipo').setValue(this.data.embedTipo)
    this.form.get('image').setValue(this.data.image)
    console.log(this.data)

    setTimeout(() => {
      this.loading = false;
      setTimeout(() => {
        const elemSidebar = <HTMLElement>document.querySelector('.perfect-scroll');
        const ps = new PerfectScrollbar(elemSidebar, {wheelSpeed: 2, suppressScrollX: true});
      }, 1);
    }, 1000);
  }

  removeEmbed() {
    this.form.get('embed').setValue('');
    this.form.get('embedTipo').setValue('');
  }

  removeImage() {
    this.form.get('image').setValue('');
  }

  getUsuarioLogado(): any {
    const loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));

    this.loggedInUser = loggedUser.data;
  }

  buildForm(): void {
    this.form = this.fb.group({
      id: [''],
      texto: ['', Validators.minLength(5)],
      pasta_id: [''],
      title: [''],
      embed: [''],
      embedTipo: [''],
      image: ['']
    });
  }


  onSubmit(): any {
    this.loading = true;
    this.feedService.publishUpdatePost(this.preparePostItem())
      .subscribe(res => {
        this.dialogRef.close(true)
      });
    this.form.reset();
  }

  preparePostItem(): Feed {
    const formModel = this.form.value;
    const feed = new Feed();
    const embed = this.checkIfHasEmbededVideo(formModel.texto);

    // @TODO: Resolver problema de pasta forçada

    feed.embedTipo = formModel.embedTipo;
    feed.image = formModel.image;
    feed.embed = formModel.embed;
    feed.id = formModel.id;
    feed.pasta_id = 1;
    feed.titulo = formModel.texto;
    feed.texto = formModel.texto;
    feed.author = this.loggedInUser.name;

    if (typeof embed === 'object') {
      feed.embed = embed.url;
      feed.texto = '';
      feed.titulo = 'Embed';
    }

    if (this.uploadedFileUrl && this.uploadedFileType === 'video') {
      feed.embedTipo = formModel.embedTipo;
      feed.embed = formModel.embed;
    }

    if (this.uploadedFileUrl && this.uploadedFileType === 'image') {
      feed.image = formModel.image;
    }

    this.resetFilePicker();

    return feed;
  }



  checkIfHasEmbededVideo(value: string): any {
    if (value.includes('vimeo')) {
      return {url: '//player.vimeo.com/video/' + value.split('/')[4]};
    } else if (value.includes('youtube')) {
      return {url: '//www.youtube.com/embed/' + value.split('=')[1]};
    } else {
      return value;
    }
  }

  showFilePicker() {
    const component = this;
    client.pick({
      fromSources: ['local_file_system', 'webcam', 'video'],
      uploadInBackground: false,
      accept: ['image/*', 'video/*'],
      maxFiles: 1,
      lang: 'pt'
    }).then(function (response) {
      component.isFile = true;
      component.uploadedFileUrl = response.filesUploaded['0'].url;
      component.uploadedFileType = component.getTypeByMimeType(response.filesUploaded['0'].mimetype);
      console.log(response.filesUploaded['0'].url)
      console.log(response.filesUploaded['0'].mimetype)

      if (component.uploadedFileType === 'video') {
        component.form.get('embedTipo').setValue('file');
        component.form.get('embed').setValue(response.filesUploaded['0'].url);
      }

      if (component.uploadedFileType === 'image') {
        component.form.get('image').setValue(response.filesUploaded['0'].url);
        console.log('acabou')
      }

      console.log(response);
    });
  }

  getTypeByMimeType(mime: string): string {
    const split = mime.split('/');
    console.log(split[0])
    return split[0];
  }

  resetFilePicker() {
    this.uploadedFileType = null;
    this.uploadedFileUrl = null;
    this.form.get('embed').setValue('');
    this.form.get('embedTipo').setValue('');
    this.form.get('image').setValue('');
    this.isFile = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/feed/modal-content/modal-content.component.ts